import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { GenerateEventSessionsContext } from "./GenerateEventSessionsContext";
import execute from "@beeldit/core/services/execute";

function useExecuteGenerateEventSessions() {
  const errorHandler = useErrorHandler();
  const { modelId, element, setBackendFormErrors } = useContext(GenerateEventSessionsContext);  
  return (onSuccess: any) => {
    execute(`events/generate-event-sessions/${modelId}`, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useExecuteGenerateEventSessions;
